var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotovoltaic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 264,
    viewBox: "0 0 258 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_79)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: -3,
    width: 184.555,
    height: 184.555,
    rx: 14,
    transform: "rotate(45 129 -3)",
    fill: "#008E81"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: -2.29289,
    width: 183.555,
    height: 183.555,
    rx: 13.5,
    transform: "rotate(45 129 -2.29289)",
    stroke: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6354 71L157.092 71V71C160.821 70.9996 164.191 73.6478 165.656 77.7304V77.7304L165.659 77.738L191.248 148.831C192.48 152.259 192.185 156.197 190.462 159.31C188.738 162.423 185.818 164.297 182.687 164.3H75.3173V164.3C72.2908 164.301 69.4508 162.55 67.7051 159.605C65.9592 156.66 65.5241 152.888 66.5386 149.491L87.8543 78.4044L87.8579 78.3925C89.1732 73.9644 92.6907 71.0025 96.6354 71ZM96.6371 81.3493C96.373 81.3498 96.1379 81.5484 96.0501 81.845L96.0442 81.865L74.7261 152.959V152.959C74.6589 153.186 74.6876 153.44 74.8042 153.636C74.9211 153.833 75.1111 153.951 75.3138 153.951H182.681C182.893 153.95 183.09 153.824 183.207 153.613C183.323 153.403 183.343 153.138 183.26 152.906V152.906L157.667 81.8004C157.569 81.5268 157.342 81.3493 157.092 81.3493H96.6371Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.035 153.951C115.434 153.951 117.38 156.267 117.38 159.125V182.825C117.38 185.683 115.434 188 113.035 188C110.635 188 108.69 185.683 108.69 182.825V159.125C108.69 156.267 110.635 153.951 113.035 153.951Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.885 153.951C145.285 153.951 147.23 156.267 147.23 159.125V182.825C147.23 185.683 145.285 188 142.885 188C140.486 188 138.54 185.683 138.54 182.825V159.125C138.54 156.267 140.486 153.951 142.885 153.951Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.96 71C130.36 71 132.305 73.3168 132.305 76.1747V159.125C132.305 161.983 130.36 164.3 127.96 164.3C125.56 164.3 123.615 161.983 123.615 159.125V76.1747C123.615 73.3168 125.56 71 127.96 71Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1268 111.725C78.1268 108.867 80.0721 106.55 82.4718 106.55H173.197C175.597 106.55 177.542 108.867 177.542 111.725C177.542 114.583 175.597 116.9 173.197 116.9H82.4718C80.0721 116.9 78.1268 114.583 78.1268 111.725Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_79",
    x: 0.298998,
    y: 2.799,
    width: 257.402,
    height: 257.402,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_79"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_79",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotovoltaic);
export default __webpack_public_path__ + "static/media/photovoltaic.b3457fb7bc94cac6a51488815b26dde7.svg";
export { ForwardRef as ReactComponent };